var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 55,
    viewBox: "0 0 84 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 2,
    d: "M57 21h5a3 3 0 0 1 3 3v30H54V24a3 3 0 0 1 3-3zM38 32h5a3 3 0 0 1 3 3v19H35V35a3 3 0 0 1 3-3zM19 41h5a3 3 0 0 1 3 3v10H16V44a3 3 0 0 1 3-3z",
    opacity: 0.521
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9C9C9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11 54h61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "nonzero",
    d: "M59.65.37a1.16 1.16 0 0 0-.91-.367L51.43 0c-.661 0-1.198.566-1.198 1.264 0 .699.537 1.265 1.199 1.265h4.477L44.06 15.027l-4.468-4.713a1.168 1.168 0 0 0-.848-.37c-.318 0-.623.133-.847.37L22.35 29.842a1.314 1.314 0 0 0 0 1.788c.234.247.54.37.847.37.307 0 .614-.123.848-.37l14.698-18.634 4.468 4.713a1.155 1.155 0 0 0 1.695 0L57.603 4.317V8.59c0 .698.537 1.264 1.198 1.264.662 0 1.199-.566 1.199-1.264v-7.2c.014-.407-.101-.757-.35-1.02z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C5C5C5",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 27v13M0 34h14"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 37,
    r: 4,
    stroke: "#C6C6C6",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/noOrders.ab7d7061160410c90f58b6cf96e13ff9.svg";
export { ForwardRef as ReactComponent };